import React, { useRef, useState, useEffect, useContext, useMemo } from 'react'
import { PicturePreview } from 'baseComponent'
import getImage from 'common/getImage'
import { ossImg } from 'meinian-package/src/utils/image'
import RenderBoxList from './renderBoxList'
import OuterChange from './outerChange'
import NewAnnotate from '../annotate/newAnnotate'
import { NoteLabel } from '../annotate/note'
import { IMAGE_DETAIL_TAB } from '../infoView'
import type { IImageDetailContext } from '../content'
import type { SampleDetailContext } from '../../sampleDetail/content'
import styles from './index.module.less'

export const adaImage = (imgInfo, canvasDom) => {
  const canvasWidth = canvasDom.width
  const canvasHeight = canvasDom.height > document.body.clientHeight ? document.body.clientHeight : canvasDom.height
  let wrapperWidth = canvasWidth
  let wrapperHeight = canvasHeight
  if (imgInfo.width / imgInfo.height > canvasWidth / canvasHeight) {
    wrapperWidth = canvasWidth
    wrapperHeight = (imgInfo.height * canvasWidth) / imgInfo.width
  } else {
    wrapperHeight = canvasHeight
    wrapperWidth = (imgInfo.width * canvasHeight) / imgInfo.height
  }
  return {
    width: wrapperWidth,
    height: wrapperHeight,
  }
}

export default ({
  setInnerIndex,
  innerIndex,
  imgInfoList,
  currentImage,
  setBanOperation,
  onOuterChange,
  maxListLength,
  currentIndexInList,
  scale,
  setScale,
  showNoteLabel,
  showBox,
  content,
}) => {
  const {
    tabValue,
    notes,
    onInitNotes,
    setNotes,
    isMove,
    setIsMove,
    activeNoteIndex,
    setActiveNoteIndex,
    isAnnotate,
    setIsAnnotate,
    showRight,
    isPage,
    boxIndex,
    setBoxIndex,
  }: IImageDetailContext | SampleDetailContext = useContext(content)

  const [isDraw, setIsDraw] = useState(false)
  const $annotateContainer = useRef(null)
  const { mainUrl, width, height } = currentImage || {}
  const picInfo = { src: mainUrl, picWidth: width, picHeight: height }
  const [originImage, setOriginImage] = useState<any>({
    width,
    height,
  })

  useEffect(() => {
    setOriginImage({
      width,
      height,
    })
    getImage(mainUrl)
      .then((img) => {
        setOriginImage({
          width: img.naturalWidth,
          height: img.naturalHeight,
        })
      })
      .catch(() => {
        setOriginImage({
          width,
          height,
        })
      })
  }, [currentImage])

  const annotationWrapStyle = useMemo(() => {
    if (tabValue === IMAGE_DETAIL_TAB.ANNOTATION) {
      return {}
    }
    return {
      paddingLeft: '214px',
      paddingRight: '110px',
    }
  }, [tabValue])

  return (
    <div className={styles['imgs-and-pagination']} ref={$annotateContainer} style={annotationWrapStyle}>
      {!isPage && <OuterChange maxLength={maxListLength} outerIndex={currentIndexInList} onOuterChange={onOuterChange} />}
      <div className={styles['meinian-image-detail-picture']}>
        {tabValue !== IMAGE_DETAIL_TAB.ANNOTATION && (
          <Main
            mainUrl={mainUrl}
            originImage={originImage}
            picInfo={picInfo}
            setBanOperation={setBanOperation}
            notes={notes}
            showBox={showBox}
            boxIndex={boxIndex}
            key={tabValue}
            setBoxIndex={setBoxIndex}
            currentImage={currentImage}
            showNoteLabel={showNoteLabel}
          >
            <>
              <Arrow step={-1} imgInfoList={imgInfoList} innerIndex={innerIndex} setInnerIndex={setInnerIndex} type="prev" />
              <Arrow step={1} imgInfoList={imgInfoList} innerIndex={innerIndex} setInnerIndex={setInnerIndex} type="next" />
            </>
          </Main>
        )}
        {tabValue === IMAGE_DETAIL_TAB.ANNOTATION && (
          <NewAnnotate
            className="img-annotate-container"
            imageInfo={currentImage}
            originImage={originImage}
            scale={scale}
            setScale={setScale}
            isAnnotate={isAnnotate}
            setIsAnnotate={setIsAnnotate}
            notes={notes}
            setNotes={setNotes}
            fetchNotes={onInitNotes}
            isMove={isMove}
            setIsMove={setIsMove}
            activeNoteIndex={activeNoteIndex}
            setActiveNoteIndex={setActiveNoteIndex}
            isDraw={isDraw}
            setIsDraw={setIsDraw}
            showRight={showRight}
          />
        )}
      </div>
    </div>
  )
}

const Main = ({
  mainUrl,
  originImage,
  picInfo,
  setBanOperation,
  notes,
  showBox,
  boxIndex,
  setBoxIndex,
  currentImage,
  showNoteLabel,
  children,
}) => {
  const domRef = useRef(null)
  const [imageSize, setImageSize] = useState(originImage)

  useEffect(() => {
    const onResize = () => {
      const imageSize = adaImage(originImage, {
        width: domRef.current.clientWidth,
        height: domRef.current.clientHeight,
      })
      setImageSize(imageSize)
    }
    onResize()
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [originImage, domRef.current])
  return (
    <div className={styles.picture} ref={domRef}>
      {children}
      <div style={{ ...imageSize, position: 'relative' }}>
        <img
          referrerPolicy="no-referrer"
          src={ossImg(mainUrl, 2000, 2000)}
          className={styles['meinian-image-detail-main-image']}
        />
        <div
          className={styles.scale}
          onClick={() => {
            PicturePreview.show(picInfo, setBanOperation)
            setBanOperation(true)
          }}
        />
        {showBox && (
          <RenderBoxList currentImage={currentImage} boxIndex={boxIndex} setBoxIndex={setBoxIndex} originImage={originImage} />
        )}
        {showNoteLabel && (
          <div>
            {notes?.map((item, index) => (
              <NoteLabel data={item} index={notes.length - index} key={index} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

const Arrow = ({ imgInfoList, type, step, innerIndex, setInnerIndex }) => (
  <div
    className={`arrow-container ${type}`}
    onClick={(e) => {
      e.stopPropagation()
      setInnerIndex(innerIndex + step)
    }}
    style={{ display: imgInfoList[innerIndex + step] ? 'flex' : 'none' }}
  />
)
